<div id="{{target}}" class="map"></div>
<div id="popup-barrios" class="ol-popup popBarrio">
  <span id="popup-barrios-closer" class="ol-popup-closer" (click)="closePopUp()"></span>
  <div id="popup-barrios-content">
    <div *ngIf="subBarrioSelected">
          <p>{{subBarrioSelected.nombre}}</p>
          <p-chart type="doughnut" [data]="{
            labels: ['Libre %', 'Ocupada %'],
            datasets: [
            {
              data: [ (100 - subBarrioSelected.ocupacionMedia).toFixed(2),subBarrioSelected.ocupacionMedia.toFixed(2)],
              backgroundColor: [green,red],
              hoverBackgroundColor: [green,red]
            }
            ]}"></p-chart>
            <p><b>{{'GLOBAL.PLAZAS.TOTALES' |translate}} :</b> {{subBarrioSelected.plazasTotales}}</p>
            <p><b>{{'GLOBAL.PLAZAS.OCUPADAS' |translate}} :</b> {{subBarrioSelected.plazasTotales - subBarrioSelected.plazasDisponible}}</p>
            <p><b>{{'GLOBAL.PLAZAS.DISPONIBLES' |translate}} :</b> {{subBarrioSelected.plazasDisponible}}</p>
    </div>
  </div>
</div>

